import useAsyncDataState from './useAsyncDataState'

export default (asyncFunction) => {
  const {
    setState: { onAttempt, onFailure, onSuccess },
    state,
  } = useAsyncDataState()

  const makeRequest = (...arguments_) => {
    onAttempt()
    return asyncFunction(...arguments_).then(
      (response) => {
        onSuccess(response)
        return response
      },
      (error) => {
        onFailure(error)
        throw error
      },
    )
  }

  return {
    ...state,
    makeRequest,
  }
}
